import { render, staticRenderFns } from "./register-full.vue?vue&type=template&id=5b307fba&"
import script from "./register-full.vue?vue&type=script&lang=js&"
export * from "./register-full.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports